<template>
  <div>
    <v-radio-group
      ref="campo"
      v-bind="$attrs"
      :label="labelDefault"
      v-model="model"
      :rules="rules"
      v-on="$listeners"
      :data-cy="$attrs.label || $attrs.name">
  <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
    <slot :name="slotName" v-bind="context" />
  </template>
      <template v-for="(_, name) in $slots" v-slot:[name]>
        <slot :name="name" />
      </template>
    <template v-if="!$scopedSlots.message" v-slot:message="{ message, key }">
      <v-icon v-if="$api.UI.showErrorIcon($el)" x-small color="error" class="mr-1 pb-1">{{$theme.options.iconError}}</v-icon>
      <span v-html="message" :key="key"></span>
    </template>
    </v-radio-group>
  </div>
</template>
<script>
export default {
  props: {
    value: [Number, String]
  },
  computed: {
    labelDefault: function () {
      return (
        this.$attrs.label ? this.$attrs.label +
        (this.$attrs.required === '' || this.$attrs.required === true ? ' *' : '')
          : ''
      )
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    rules () {
      const name = this.$attrs.name || this.$attrs.label || ''

      const errors = []
      if (this.$attrs.required === '' || this.$attrs.required === true) {
        !!this.model || errors.push(name + ' é obrigatório.')
      }

      if (this.$refs && this.$refs.campo && this.$refs.campo.$el) {
        this.$refs.campo.$el.setAttribute(
          'data-message',
          errors ? errors[0] : ''
        )
        this.$refs.campo.$el.setAttribute('data-invalid', errors.length > 0)
      }

      return errors
    }
  }
}
</script>
